import {useRef, useEffect} from 'react';
import {noop} from '@priority-software/priority-style-react';

export function useEventListener(
    eventName: string,
    handler,
    element: Window | HTMLElement = window,
    options?: boolean | AddEventListenerOptions
) {
    const savedHandler = useRef(null);

    useEffect(() => {
        // Update ref.current value if handler changes.
        savedHandler.current = handler;
    }, [handler]);

    useEffect(
        () => {
            // Check if element supports addEventListener
            if (!element?.addEventListener) return noop;
            // Create event listener that calls handler function stored in ref
            const eventListener = event => savedHandler.current?.(event);

            element.addEventListener(eventName, eventListener, options);
            return () => element.removeEventListener(eventName, eventListener, options);
        },
        [eventName, element, options] // Re-run if eventName or element changes
    );
}
